<!-- src/app/pages/press/press.component.html -->
<section class="press-page">
  <div class="container">

    <div class="hero">
      <h1>Press & Media Kit</h1>
      <p class="hero-sub">Resources for journalists, bloggers, and media covering Lydia Christensen's 2026 Michigan U.S. Senate campaign.</p>
    </div>

    <!-- PRESS CONTACT -->
    <div class="press-grid">
      <div class="press-card press-card--contact">
        <h2>Press Contact</h2>
        <div class="contact-block">
          <div class="contact-block__name">Lydia Christensen</div>
          <div class="contact-block__title">Candidate & Campaign Manager</div>
          <a href="mailto:senator@lydialynnchristensen.com" class="contact-block__email">senator@lydialynnchristensen.com</a>
          <p class="contact-block__note">Media inquiries are typically responded to within 24 hours. For urgent requests, also reach out via <a href="https://discord.gg/DNqwMBsycY" target="_blank" rel="noopener noreferrer">Discord</a>.</p>
        </div>
        <div class="fast-facts">
          <h3>Fast Facts</h3>
          <ul>
            <li><strong>Candidate:</strong> Lydia Christensen</li>
            <li><strong>Office:</strong> U.S. Senate, Michigan</li>
            <li><strong>Party:</strong> Libertarian</li>
            <li><strong>From:</strong> Ironwood, MI (Upper Peninsula)</li>
            <li><strong>FEC ID:</strong> C00903575</li>
            <li><strong>Primary:</strong> August 4, 2026</li>
            <li><strong>General:</strong> November 3, 2026</li>
            <li><strong>Slogan:</strong> "Unchain Michigan"</li>
          </ul>
        </div>
      </div>

      <!-- DOWNLOADS -->
      <div class="press-card">
        <h2>Downloadable Assets</h2>
        <div class="asset-list">
          <a href="assets/Logo.png" download class="asset-item">
            <div class="asset-item__icon">🖼️</div>
            <div>
              <div class="asset-item__name">Campaign Logo (PNG)</div>
              <div class="asset-item__desc">Primary logo for use in print and digital media</div>
            </div>
          </a>
          <a href="assets/bannerFinalizedNoStars.png" download class="asset-item">
            <div class="asset-item__icon">🖼️</div>
            <div>
              <div class="asset-item__name">Campaign Banner (PNG)</div>
              <div class="asset-item__desc">Horizontal banner for headers and social sharing</div>
            </div>
          </a>
          <a href="assets/lydia-christensen-campaign.jpg" download class="asset-item">
            <div class="asset-item__icon">📸</div>
            <div>
              <div class="asset-item__name">Candidate Photo</div>
              <div class="asset-item__desc">High-resolution photo for press use</div>
            </div>
          </a>
        </div>
      </div>

      <!-- BIO -->
      <div class="press-card press-card--bio">
        <h2>Candidate Bio</h2>
        <p class="bio-short"><strong>Short bio (1 sentence):</strong><br>
        Lydia Christensen is the Libertarian Party candidate for U.S. Senate in Michigan, running to give the state an unchained voice free from establishment politics and corporate influence.</p>
        <p class="bio-medium"><strong>Medium bio (2–3 sentences):</strong><br>
        Lydia Christensen is the Libertarian Party candidate for Michigan's open U.S. Senate seat in 2026. Born into a family from Ironwood, MI, she was inspired by the Upper Peninsula's waterfalls and natural beauty to fight for Michigan's environment, economy, and individual liberty. She built this entire campaign herself - website, platform, and grassroots organizing - without establishment backing or corporate donors.</p>
        <p class="bio-full"><strong>Full bio:</strong><br>
        Lydia Christensen is running for U.S. Senate in Michigan as the Libertarian Party nominee, operating under the motto "Unchain Michigan." She believes that both major parties have failed the state, using Michigan as a bargaining chip rather than fighting for its people. Lydia's family roots are in Ironwood, MI - in the heart of the Upper Peninsula - and her campaign priorities reflect that heritage: protecting the Great Lakes, expanding economic opportunity in rural and UP communities, advancing LGBTQ+ rights and social equity, and championing digital rights and responsible cryptocurrency policy. She has no corporate PAC backing and built this campaign - including its website and legislative tracking tools - entirely herself. As the Libertarian nominee, Lydia has automatic ballot access; her Constitutional Captains program now has volunteers knocking the 12,000–15,000 doors needed to win by Election Day, November 3, 2026.</p>
      </div>

      <!-- COVERAGE GUIDELINES -->
      <div class="press-card">
        <h2>Coverage Guidelines</h2>
        <ul class="guidelines">
          <li>Lydia identifies as the <strong>Libertarian Party</strong> candidate.</li>
          <li>The correct campaign name is <strong>"Lydia Christensen for United States Senate"</strong>.</li>
          <li>The campaign slogan is <strong>"Unchain Michigan"</strong>.</li>
          <li>FEC ID for financial disclosure lookups: <strong>C00903575</strong>.</li>
          <li>For interview requests, email <a href="mailto:senator@lydialynnchristensen.com">senator@lydialynnchristensen.com</a>.</li>
        </ul>
        <div class="social-links-press">
          <h3>Official Social Accounts</h3>
          <ul>
            <li>Facebook: <a href="https://www.facebook.com/profile.php?id=61574235554571" target="_blank" rel="noopener noreferrer">facebook.com/LydiaChristensen</a></li>
            <li>TikTok: <a href="https://www.tiktok.com/@lydiaforussenate" target="_blank" rel="noopener noreferrer">@lydiaforussenate</a></li>
            <li>Bluesky: <a href="https://bsky.app/profile/lydiaforussenate.bsky.social" target="_blank" rel="noopener noreferrer">@lydiaforussenate.bsky.social</a></li>
            <li>Discord: <a href="https://discord.gg/DNqwMBsycY" target="_blank" rel="noopener noreferrer">discord.gg/DNqwMBsycY</a></li>
          </ul>
        </div>
      </div>
    </div>

    <!-- PRESS RELEASES LINK -->
    <div class="press-cta">
      <h2>Press Releases</h2>
      <p>All official press releases are published in the campaign Newsroom.</p>
      <a routerLink="/newsroom" class="btn-primary">Visit the Newsroom</a>
    </div>

  </div>
</section>
